/*
 * @Description: t
 * @version:
 * @Author: lijing
 * @Date: 2022-07-15 14:04:16
 * @LastEditors: yangfan yangfan@caixm.cn
 * @LastEditTime: 2025-10-28 19:15:26
 */
import moment from 'moment';
import { fixedZeroTo4Bit } from '../../../src/utils/utils';

const operationTypes = [
  { value: '', label: '全部' },
  { value: 1, label: '修改买家姓名' },
  { value: 2, label: '修改货主姓名' },
  { value: 3, label: '修改订单' },
  { value: 4, label: '作废订单' },
  { value: 5, label: '撤销还款' },
  { value: 7, label: '买家合并' },
  { value: 8, label: '买家拆解' },
  { value: 9, label: '取消结算' },
  { value: 10, label: '删除收支' },
  { value: 12, label: '补录还款' },
  { value: 13, label: '补录收筐' },
  { value: 14, label: '补录收支' },
  { value: 15, label: '删除收筐' },
  { value: 18, label: '补录结算' },
  { value: 19, label: '补录费用' },
];

const dateFormat = 'YYYY-MM-DD HH:mm';

const actionMap = {
  1: (before, after) => `将【${before.buyerName}】修改为【${after.buyerName}】`,
  2: (before, after) => `将【${before.supplierName}】修改为【${after.supplierName}】`,
  3: (before) => `修改${before.buyerName}的订单，票号【${fixedZeroTo4Bit(before.todayNo, 4)}】`,
  4: (before) => `作废${before.buyerName}的订单，票号【${fixedZeroTo4Bit(before.todayNo, 4)}】`,
  5: (before) =>
    `撤销${before.buyerName}的还款【${before.amount}元】，还款时间【${moment(
      before.createTime,
    ).format(dateFormat)}】`,
  7: (before) => `买家【${before.masterName}】将【${before.buyerName}】合并了`,
  8: (before) => `买家【${before.masterName}】将【${before.buyerName}】拆解了`,
  9: (before) => `取消【${before.supplierName}${fixedZeroTo4Bit(before.carNo, 4)}】的结算单`,
  10: (before) =>
    `删除${before.inOutType || ''}：${before.expendTypeName || ''}【${
      before.amount
    }元】，录入时间【${moment(before.createTime).format(dateFormat)}】`,
  12: (before) =>
    `补录${before.buyerName}的还款【${before.amount}元】，时间【${moment(before.createTime).format(
      dateFormat,
    )}】`,
  13: (before) =>
    `补录${before.buyerName}的收筐【${before.basketAmount}元】，时间【${moment(
      before.createTime,
    ).format(dateFormat)}】`,
  14: (before) =>
    `补录${before.inOutType}：${before.expendTypeName || ''}【${before.amount}元】，时间【${moment(
      before.createTime,
    ).format(dateFormat)}】`,
  15: (before) => `删除${before.buyerName}的收筐【${before.basketAmount}元】`,
  18: (before) =>
    `补录【${before.supplierName || ''}${fixedZeroTo4Bit(
      before.carNo,
      4,
    )}】的结算单，时间【${moment(before.settlementTime).format(dateFormat)}】`,
  19: (before) =>
    `补录费用：${before.expendTypeName || ''}【${before.amount}元】，时间【${moment(
      before.createTime,
    ).format(dateFormat)}】`,
};

export { operationTypes, actionMap };
